import React from "react";
import { FaUserCheck, FaFileInvoiceDollar, FaUsers, FaCode } from "react-icons/fa";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const AccountStatus = () => {
  const userAccountData = {
    accountStatus: "Activo",
    nextInvoice: "$50.00 - 15 de Febrero de 2025",
    totalReferrals: 12,
    referralCode: "HVLorenzoPi",
  };

  const referralsData = {
    labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio"],
    datasets: [
      {
        label: "Referidos",
        data: [2, 4, 6, 8, 10, 12, 15],
        backgroundColor: "rgba(29, 78, 216, 0.2)",
        borderColor: "#1d4ed8",
        borderWidth: 2,
      },
    ],
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 bg-gray-50 p-6 rounded-lg shadow">
      {/* Account Status */}
      <div className="flex items-center p-4 bg-white rounded-lg shadow border border-gray-200">
        <FaUserCheck className="text-green-500 text-3xl mr-4" />
        <div>
          <h3 className="text-lg font-bold">Estado de la Cuenta</h3>
          <p className="text-gray-500">{userAccountData.accountStatus}</p>
        </div>
      </div>

      {/* Next Invoice */}
      <div className="flex items-center p-4 bg-white rounded-lg shadow border border-gray-200">
        <FaFileInvoiceDollar className="text-blue-500 text-3xl mr-4" />
        <div>
          <h3 className="text-lg font-bold">Siguiente Factura</h3>
          <p className="text-gray-500">{userAccountData.nextInvoice}</p>
        </div>
      </div>

      {/* Total Referrals */}
      <div className="flex items-center p-4 bg-white rounded-lg shadow border border-gray-200">
        <FaUsers className="text-indigo-500 text-3xl mr-4" />
        <div>
          <h3 className="text-lg font-bold">Total de Referidos</h3>
          <p className="text-gray-500">{userAccountData.totalReferrals}</p>
        </div>
      </div>

      {/* Referral Code */}
      <div className="flex items-center p-4 bg-white rounded-lg shadow border border-gray-200">
        <FaCode className="text-purple-500 text-3xl mr-4" />
        <div>
          <h3 className="text-lg font-bold">Código de Referido</h3>
          <p className="text-gray-500">{userAccountData.referralCode}</p>
        </div>
      </div>

      {/* Growth Chart */}
      <div className="col-span-1 sm:col-span-2 lg:col-span-4 bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-bold mb-4">Crecimiento de Referidos</h3>
        <Line data={referralsData} />
      </div>
    </div>
  );
};

export default AccountStatus;
